import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IFindNumberOfSheetsEnabledForAccelerationParams {
}

export interface IFindNumberOfSheetsEnabledForAccelerationResult extends IResult {
  numOfEnabledSheets: number;
}

export class FindNumberOfSheetsEnabledForAccelerationRequest extends
    Request<IFindNumberOfSheetsEnabledForAccelerationParams, IFindNumberOfSheetsEnabledForAccelerationResult> {
  constructor() {
    super('findNumberOfSheetsEnabledForAcceleration', {});
  }
}
